/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
* Grouped columns for comparing one series against another across the same categories.
* Same analysis as the trendline - the trend field gives the categories along the bottom and
* the picklist gives one series per value - but drawn unstacked, so this year stands beside
* the previous one a month at a time rather than sitting on top of it.
*/
import { TrendLine } from "@src/app/shared/chart/charts/trend-line";

export class CompareBar extends TrendLine {

    protected createChartOptions() {

        return {
            chart: {
                backgroundColor: this.chartBackgroundColor,
                borderRadius: this.chartBorderRadius,
                plotBorderWidth: null,
                type: 'column',
                height: this.height,
            },
            title: this.getChartTitle(),
            credits: { enabled: false },
            tooltip: this.getTooltip(),
            xAxis: {
                categories: this.categories,
            },
            yAxis: {
                title: { text: (this.numberField ? this.numberField.label : 'Count') },
            },
            plotOptions: {
                column: {
                    borderWidth: 0,
                    groupPadding: 0.1,
                },
            },
            series: this.series
        };
    }
}
